import { getCookie, setCookie } from './utils/cookies'

$('body').on('click', '.close-cookie-modal', function (e) {
  e.preventDefault()

  setCookie('vidi-cookies-agreed', '1', 30)
  $('.cookies').fadeOut()
})

if(!getCookie('vidi-cookies-agreed')) {
  $('.cookies').addClass('is-visible')
}
